import { defineComponent as _defineComponent } from 'vue'
import ConnectorComponent from "@/components/ui/ConnectorComponent"
import type { Connector } from "@/models/common"

interface ConnectorsComponentProps {
  connectors: Connector[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectorsComponent',
  props: {
    connectors: { default: () => [] }
  },
  emits: ["connectorselected"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit

const onClickChild = (obj: Connector) => {
  emit("connectorselected", obj)
}

const __returned__ = { emit, onClickChild, get ConnectorComponent() { return ConnectorComponent } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})